import { gql, useMutation } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const SUBMIT_SERVICE_CHECK = gql`
  mutation SubmitServiceCheck($input: SubmitServiceCheckInput!, $token: String) {
    submitServiceCheck(input: $input, token: $token) {
      id
      status
      verdict
      inputServiceName
      inputCategory
    }
  }
`;

export interface SubmitServiceCheckInput {
  serviceName: string;
  serviceUrl?: string | null;
  category: string;
}

export interface SubmitServiceCheckData {
  submitServiceCheck: {
    id: string;
    status: 'PENDING' | 'COMPLETED' | 'FAILED';
    verdict: 'RELEVANT_ADDED' | 'NOT_RELEVANT' | 'WRONG_CATEGORY' | 'DUPLICATE' | null;
    inputServiceName: string;
    inputCategory: string;
  };
}

export interface SubmitServiceCheckVariables {
  input: SubmitServiceCheckInput;
  token?: string | null;
}

export function useSubmitServiceCheckMutation() {
  const { token } = useShareTokenJwt();
  const [mutate, result] = useMutation<SubmitServiceCheckData, SubmitServiceCheckVariables>(SUBMIT_SERVICE_CHECK);
  const wrapped: typeof mutate = (options) =>
    mutate({ ...options, variables: { ...(options?.variables as SubmitServiceCheckVariables), token } });
  return [wrapped, result] as const;
}
